<template>
    <div>
        <h2 class="text-base font-medium text-gray-700 mb-1 text-center">Status</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4 text-sm" :key="renderKey">
            <div v-html="getStatus()"></div>
            <div v-if="!user.connected" class="text-red-600 text-xs mt-2">Remote connection lost, attempting to
                re-connect...
            </div>

            <div class="flex w-full mt-3 pt-3 border-t border-gray-200" v-if="!loadedApplicationForPayment.locked">
                <div class="text-sm flex-1 pt-1">Edit Mode</div>
                <div class="text-right pl-4 text-sm font-open-sans tabular-nums font-semibold">
                    <ui-toggle class="text-left inline-block w-auto p-0.5 rounded-xl" field="text-xs"
                               :disabled="loadedApplicationForPayment.editing && (loadedApplicationForPayment.editingByReference != user.user.id)"
                               v-model="editToggle" @input="(e) => $emit('toggleEditMode', !e)" v-if="user.user"
                    ></ui-toggle>
                </div>
            </div>
            <div v-if="user.user && loadedApplicationForPayment.editing && (loadedApplicationForPayment.editingByReference != user.user.id)"
                 class="text-red-600 text-xs mt-2">Application for Payment is currently being edited by {{ loadedApplicationForPayment.editingBy }} (since
                {{ loadedApplicationForPayment.editingSince }})
            </div>
        </div>

    </div>
</template>

<script>

import {ApplicationForPayment} from "@models";
import moment from "moment";
import User from "../../../services/User";
import UiToggle from "../../ui/UiToggle.vue";

export default {
    components: {UiToggle},
    props: {
        applicationForPayment: ApplicationForPayment,
    },
    data() {
        return {
            loadedApplicationForPayment: this.applicationForPayment,
            lastSaving: false,
            lastSaved: false,
            interval: 0,
            user: Object,
            editToggle: !this.applicationForPayment.readonly,
            renderKey: 0,
        }
    },
    methods: {
        getStatus() {
            if (this.loadedApplicationForPayment.locked) {
                return 'AFP is Locked'
            } else if (this.loadedApplicationForPayment.readonly) {
                return 'AFP in Read Only mode'
            } else if (this.loadedApplicationForPayment.saving) {
                this.interval = setTimeout(() => {
                    this.$forceUpdate();
                }, 400);
                if (moment().diff(this.lastSaving, 'seconds') > 3) {
                    return 'Saving...<br/><br/>Connection interrupt detected......   Continuing to attempt to save..'
                }
                return 'Saving...'
            } else if (this.loadedApplicationForPayment.error) {
                return '<span class="text-red-600">WARNING - Server error on save detected!</span><br/><br/>You may still make changes, but they will probably NOT survive a page reload or a switch from edit mode.<br/><br/>Please stop what you are doing and contact support to report this.<br/><br>Server message: <span class="text-red-600">' + ((this.loadedApplicationForPayment.error.data && this.loadedApplicationForPayment.error.data.message) ? this.loadedApplicationForPayment.error.data.message : JSON.stringify(this.loadedApplicationForPayment.error.data)) + '</span>'
            } else if (User.user.loggedOut) {
                User.register()
                if (User.user.loggedOut) {
                    this.interval = setTimeout(() => {
                        this.$forceUpdate();
                    }, 3000);
                    return '<span class="text-red-600">WARNING - You are not logged in!</span><br/><br/>You may still make changes, but they will NOT survive a page reload unless you log in.<br/><br/>Log in using a different browser tab to keep any changes.';
                }
            }
            return this.lastSaved ? 'Saved ' + this.lastSaved.fromNow() : 'No changes yet made';
        },
        getConnectionStatus() {
            return ''
        },
        updateRender() {
            this.renderKey++;
        }
    },
    mounted() {
        this.user = User;
        eventBus.$on('application-for-payment-saving', (applicationForPayment) => {
            this.loadedApplicationForPayment = applicationForPayment;
            this.lastSaving = moment()
            this.updateRender();
        });
        eventBus.$on('application-for-payment-saved', (applicationForPayment) => {
            this.loadedApplicationForPayment = applicationForPayment;
            this.lastSaved = moment()
            this.updateRender();
        });
    },
}
</script>
